import './PricingPlans.css';
import { pricingData } from '../../utils';

export default function PricingPlans() {

const {
  tieredMonthlyData,
  whatYouGet,
  recommendedAdBudget,
  addons,
  subscriptionDiscounts,
  terms,
  updatedMonthlyDeliverables,
  paymentInfo
} = pricingData

  return (
    <div className='Pricing-plans'>
      <div className='header'>
        <h1> Pricing Plans </h1>
        <p> (Strictly Non-Negotiable - Premium Clientele Only) </p>
      </div>

      <section className='tiered-monthly-plans-container'>
        <h1 className='main-title'> Tiered Monthly Plans </h1>

        <div className='tiered-monthly-plans'>
          {
            tieredMonthlyData.map((monthlyData, idx) => {
              return (
                <>
                  <h2 className='title'> {monthlyData.title} </h2>
                  <div className='single-tiered-monthly-plans' key={`montly-data-${idx}`}>
                    {
                      monthlyData.details.map((detail, id) => (
                        <aside className='' key={`monthly-data-detail-${id}`}>
                          <p className='tag'> { detail.tag } </p>
                          <p className='msg'> {detail.msg} </p>
                        </aside>
                      ))
                    }
                  </div>
                </>
              )
            })
          }
        </div>
      </section>

      <section className='what-you-get-container'>
        <h1 className='main-title orange-bg'> {whatYouGet.title} </h1>
        <ul>
          {
            whatYouGet.list.map((item, idx) => (
              <li key={`what-you-get-${idx}`}> {item} </li>
            ))
          }
        </ul>
      </section>

      <section className='recommended-ad-budget-container'>
        <h1 className='main-title'> {recommendedAdBudget.title} </h1>
        <p className='subtitle'> {recommendedAdBudget.subtitle} </p>
        
        <div className='recommended-ad-budget'>
          {
            recommendedAdBudget.details.map((budget, idx) => (
              <aside>
                {
                  budget.map((singleBudget, budgetId) => (
                    <p key={`budgetId-${budgetId}`}> {singleBudget} </p>
                  ))
                }
              </aside>
            ))
          }
        </div>
      </section>

      <section className='addons-container'>
        <h1 className='main-title'> {addons.title} </h1>
        <div className='addons'>
          {
            addons.details.map((addon, addonId) => (
              <ul key={addonId}>
                {
                  addon.map((singleAddon, singleAddonId) => (
                      <li key={`addonId-${singleAddonId}`}> { singleAddon } </li>
                    ))
                  }
              </ul>
            ))
          }
        </div>
      </section>

      <section className='discounts-container'>
        <h1 className='main-title'> {subscriptionDiscounts.title} </h1>
        <div className='discounts'>
          {
            subscriptionDiscounts.details.map((discount, discountId) => (
              <ul key={discountId}>
                {
                  discount.map((singleDiscount, singleDiscountId) => (
                      <li key={`discount-${singleDiscountId}`}> { singleDiscount } </li>
                    ))
                  }
              </ul>
            ))
          }
        </div>
      </section>

      <section className="terms-container">
        <h1 className='main-title orange-bg'> {terms.title} </h1>
        <div className='terms'>
          <ul>
            {
              terms.details.map((detail, termId) => (
                <li key={`termId-${termId}`}> {detail} </li>
              ))
            }
          </ul>
        </div>
      </section>

      <section className='updated-monthly-deliveriables-container'>
        <h1 className='main-title'> {updatedMonthlyDeliverables.title} </h1>
        <div className='updated-monthly-deliverables'>
          {
            updatedMonthlyDeliverables.details.map((deliverable, deliverableId) => {
              return (
                <div className='deliverable'>
                  <h2 className='title orange-bg'> {deliverable.tag} <span> {deliverable.price} </span> </h2>
                  <p className='heading'> {deliverable.heading} </p>

                  <ul>
                    {
                      deliverable.list.map((singleDeliverable, singleDeliverableId) => (
                        <li key={`singleDeliverableId-${singleDeliverableId}`}> {singleDeliverable} </li>
                      ))
                    }
                  </ul>

                  <p className='deliverable-note'> {deliverable.note} </p>
                </div>
              )
            })
          }
        </div>
      </section>

      <section className="payment-info">
        <h1 className='main-title'> {paymentInfo.title} </h1>
        <p className='msg'> {paymentInfo.msg} </p>

        <p> Account Name: <span> {paymentInfo.acctName} </span> </p>
        <p> Bank: <span> {paymentInfo.bank} </span> </p>
        <p> Account Number: <span> {paymentInfo.acctNumber} </span> </p>

        <p> {paymentInfo.note} </p>
        <p> {paymentInfo.sideNote} </p>
      </section>
    </div>
  )
}
